import { useRef, useState } from "react";
import { downloadOrderDocument } from "../screens/firm-purchased-subscription/FirmPurchasedSubscriptionViewController";
import { DOCUMENT_TYPE_ENUM } from "../utils/PurchaseEnumerations";

const documentKey = (orderId: string, documentType: DOCUMENT_TYPE_ENUM) =>
  `${orderId}:${documentType}`;

const UseOrderDocumentDownloadHook = () => {
  const busyRef = useRef<string | null>(null);
  const [busyKey, setBusyKey] = useState<string | null>(null);

  const download = async (orderId: string, documentType: DOCUMENT_TYPE_ENUM) => {
    if (busyRef.current) return;
    busyRef.current = documentKey(orderId, documentType);
    setBusyKey(busyRef.current);
    await downloadOrderDocument(orderId, documentType);
    busyRef.current = null;
    setBusyKey(null);
  };

  const isBusy = (orderId: string, documentType: DOCUMENT_TYPE_ENUM) =>
    busyKey === documentKey(orderId, documentType);

  return { download, isBusy };
};

export default UseOrderDocumentDownloadHook;
